import type { JSX } from 'react';
import Fade from '@mui/material/Fade';
import { useIntl } from '@doxyme/locale';
import {
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalBody,
} from '@doxyme/ui/components/foundations';
import { useInviteViaEmailFreeModalContentStyles } from './inviteViaEmailFreeModalContent.styles';
import {
  InviteViaEmailTabPanel,
  type InviteViaEmailTabPanelProps,
  InviteViaEmailTabs,
  SendFromMyEmailTab,
  type SendFromMyEmailTabProps,
} from '../sendFromMyEmailTab';
import { InviteViaEmailUpsellCard } from '../inviteViaEmailUpsellCard';
import { useUserSubscription } from '../../../../hooks/useUserSubscription';

export type InviteViaEmailFreeModalContentProps = {
  onClose: () => void;
  onUpgradeSubscription: () => void;
  titleId?: string;
} & Omit<InviteViaEmailTabPanelProps, 'isPaidUser'> &
  SendFromMyEmailTabProps;

export const InviteViaEmailFreeModalContent = ({
  onClose,
  onUpgradeSubscription,
  activeTab,
  changeTab,
  inviteViaGmail,
  inviteViaYahoo,
  inviteViaOutlook,
  inviteViaDefaultEmail,
  titleId,
}: InviteViaEmailFreeModalContentProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const styles = useInviteViaEmailFreeModalContentStyles();
  const { isUpgradeButtonVisible } = useUserSubscription();

  return (
    <ModalContent>
      <ModalHeader
        title={formatMessage({ id: 'inviteViaEmail' })}
        titleId={titleId}
        onClose={onClose}
      />
      <ModalBody
        withFooter={
          activeTab !== InviteViaEmailTabs.SendFromMyEmail &&
          isUpgradeButtonVisible
        }
      >
        <InviteViaEmailTabPanel
          isPaidUser={false}
          activeTab={activeTab}
          changeTab={changeTab}
        />
        <div css={styles.tabWrapperCSS}>
          {activeTab === InviteViaEmailTabs.SendFromDoxyme && (
            <Fade in>
              <div>
                <InviteViaEmailUpsellCard />
              </div>
            </Fade>
          )}
          {activeTab === InviteViaEmailTabs.SendFromMyEmail && (
            <Fade in>
              <div>
                <SendFromMyEmailTab
                  inviteViaGmail={inviteViaGmail}
                  inviteViaYahoo={inviteViaYahoo}
                  inviteViaOutlook={inviteViaOutlook}
                  inviteViaDefaultEmail={inviteViaDefaultEmail}
                />
              </div>
            </Fade>
          )}
        </div>
      </ModalBody>

      {activeTab === InviteViaEmailTabs.SendFromDoxyme &&
        isUpgradeButtonVisible && (
          <ModalFooter
            styles={styles.modalCSS}
            submitButton={{
              children: formatMessage({ id: 'inviteVia.upgrade' }),
              type: 'upgrade',
              onClick: onUpgradeSubscription,
            }}
          />
        )}
    </ModalContent>
  );
};
